module.exports = __webpack_public_path__ + "img/ico-reaction-02.4ef27db7.svg";